export const weightedPricesLocation = "/reports/exchbusiness/weightedprices";
